"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AdminApi - axios parameter creator
 * @export
 */
exports.AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *  **Permission required**: [\"update\", \"Admin\"]
         * @summary Edit admin | Permission required: [\"update\", \"Admin\"]
         * @param {EditAdmin} [editAdmin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin: (editAdmin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/me/edit/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editAdmin, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get me admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeAdmin: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Logout admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAdmin: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"update\", \"Admin\"]
         * @summary Update admin image | Permission required: [\"update\", \"Admin\"]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminImage: (file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/me/edit/image/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
exports.AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdminApiAxiosParamCreator(configuration);
    return {
        /**
         *  **Permission required**: [\"update\", \"Admin\"]
         * @summary Edit admin | Permission required: [\"update\", \"Admin\"]
         * @param {EditAdmin} [editAdmin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin(editAdmin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editAdmin(editAdmin, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get me admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeAdmin(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMeAdmin(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Logout admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAdmin(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logoutAdmin(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"update\", \"Admin\"]
         * @summary Update admin image | Permission required: [\"update\", \"Admin\"]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminImage(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAdminImage(file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
exports.AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdminApiFp(configuration);
    return {
        /**
         *  **Permission required**: [\"update\", \"Admin\"]
         * @summary Edit admin | Permission required: [\"update\", \"Admin\"]
         * @param {EditAdmin} [editAdmin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin(editAdmin, options) {
            return localVarFp.editAdmin(editAdmin, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get me admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeAdmin(options) {
            return localVarFp.getMeAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Logout admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAdmin(options) {
            return localVarFp.logoutAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Admin\"]
         * @summary Update admin image | Permission required: [\"update\", \"Admin\"]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminImage(file, options) {
            return localVarFp.updateAdminImage(file, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     *  **Permission required**: [\"update\", \"Admin\"]
     * @summary Edit admin | Permission required: [\"update\", \"Admin\"]
     * @param {EditAdmin} [editAdmin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    editAdmin(editAdmin, options) {
        return exports.AdminApiFp(this.configuration).editAdmin(editAdmin, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get me admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    getMeAdmin(options) {
        return exports.AdminApiFp(this.configuration).getMeAdmin(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Logout admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    logoutAdmin(options) {
        return exports.AdminApiFp(this.configuration).logoutAdmin(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"update\", \"Admin\"]
     * @summary Update admin image | Permission required: [\"update\", \"Admin\"]
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    updateAdminImage(file, options) {
        return exports.AdminApiFp(this.configuration).updateAdminImage(file, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
